module.exports = __webpack_public_path__ + "static/media/energy.5781166a.jpg";